export const TPS = {value: 'TPS'};
export const TVQ = {value: 'TVQ'};
export const TVH = {value: 'TVH'};
export const INSURANCE = {value: 'INSURANCE', key: "admin.taxes.datatable.taxTypes.insurance"};

export default [TPS, TVQ, TVH, INSURANCE];



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/taxes/taxNameTypes.js